

  (function($) {
    $(() => {

        function validateForm(email, legal) {
            let error = false;
            var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
            if(!pattern.test(email) || email === '') {
                error = true;
                $('.js-error-email').addClass('error');
            } else {
                $('.js-error-email').removeClass('error');
            }

            if(!legal) {
                error = true;
                $('.js-error-legal').addClass('error');
            } else {
                $('.js-error-legal').removeClass('error');
            }

            if(error) {
                $('.js-newsletter-error-wrapper').addClass('error');
                return false;
            } else {
                $('.js-newsletter-error-wrapper').removeClass('error');
                return true;
            }
        }

        $('.js-newsletter-input').on('change keyup', function() {
            $('.js-newsletter-error-wrapper').removeClass('error');
        });

        // newsletter form
        $('.js-newsletter-form').on('submit', function (e) {
            e.preventDefault();

            if(validateForm($('#newsletter_email').val(), $('#newsletter_privacy').is(":checked"))) {
                $(this)
                .find('.js-newsletter-btn')
                .prop('disabled', true);
                const formdata = $(this).serializeArray();

                
                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'newsletter_form',
                        datas: formdata
                    },
                    success: function (data) {
                        
                        const result = JSON.parse(data);
                        console.log(result);
                        swal({
                            title: result.title,
                            text: result.message,
                            icon: result.icon,
                            button: 'ok'
                        });
                        if (result.status == 'success') {
                            $('.js-newsletter-form').trigger('reset');
                        }
    
                    }
                }).done(response => {
                    $(this)
                    .find('.js-newsletter-btn')
                    .prop('disabled', false);
                });
            }
    
        });
    });
})(jQuery);
